import React, { useEffect } from 'react';
import store from '@apply/adminStore';
import { Footer } from '../../common_v2/components/Footer';
import { Header } from '../../common_v2/components/Header';
import { MenuItemOption } from '../../common_v2/components/Header';
import { Panel, PanelTheme, PanelBorderRadius, PanelBorderStyle, useWaitOverlayStore } from '@apply/components';
import { BrokerDetailsPanel } from './components/BrokerDetailsPanel/BrokerDetailsPanel';
import { CompanyBrandingPanel } from './components/CompanyBrandingPanel/CompanyBrandingPanel';
import { PasswordResetPanel } from './components/PasswordResetPanel/PasswordResetPanel';
import { Navigate } from 'react-router';
import { isMobileScreen } from '@apply/ui';
import { useBrokerSettingsFormInit } from './hooks/useBrokerSettingsFromInit';

export const BrokerSettingsV2 = () => {
    const { user } = store.getState();
    const mobileScreen = isMobileScreen();
    const { isLoading } = useBrokerSettingsFormInit();
    const { setWaiting } = useWaitOverlayStore();

    useEffect(() => {
        if (isLoading) {
            setWaiting(true, 'Loading settings...');
        } else {
            setWaiting(false);
        }
    }, [isLoading]);

    if (!user) {
        return (
            <Navigate
                to='/login'
                replace
            />
        );
    }

    if (user && user.requiresESign) {
        return (
            <Navigate
                to='/broker/signagreement'
                replace
            />
        );
    }

    return (
        <>
            <div className='app-container'>
                <Header activeMenuItem={MenuItemOption.Settings} />
                <main>
                    <>
                        <div className='brokerSettings'>
                            <div className='brokerSettings-header'>
                                <div className={`brokerSettings-header-title ${mobileScreen ? 'mobile' : ''}`}>
                                    <h2>Settings</h2>
                                    {!mobileScreen && (
                                        <div className='brokerSettings-sectionDirections'>
                                            These are the settings and preferences we have on file for your user account.
                                        </div>
                                    )}
                                </div>
                            </div>
                            <Panel
                                theme={PanelTheme.White}
                                borderRadius={PanelBorderRadius.Medium}
                                borderStyle={PanelBorderStyle.None}
                            >
                                <div className='brokerSettings-sectionPanel'>
                                    <div className='brokerSettings-sectionPanelLeft'>
                                        <BrokerDetailsPanel />
                                    </div>

                                    <div className='brokerSettings-sectionPanelRight'>
                                        <CompanyBrandingPanel />
                                        <PasswordResetPanel />
                                    </div>
                                </div>
                            </Panel>
                        </div>
                    </>
                </main>
            </div>
            <Footer showAuthenticatedFooter={true} />
        </>
    );
};
